import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = {
  class: "form-check-label",
  for: "Single-Item-Select"
}
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = {
  class: "form-check-label",
  for: "Show-on-Menu"
}
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = {
  class: "form-check-label",
  for: "Stock-Source"
}
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = { class: "f-w-700" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "f-w-700" }
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "col-sm-6" }
const _hoisted_23 = { class: "f-w-700" }
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = { class: "col-sm-6" }
const _hoisted_27 = { class: "f-w-700" }
const _hoisted_28 = { class: "input-group" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "col-sm-6" }
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = { class: "f-w-700 pb-1" }
const _hoisted_33 = { class: "col-sm-6" }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "f-w-700" }
const _hoisted_36 = ["aria-label"]
const _hoisted_37 = {
  value: "",
  disabled: ""
}
const _hoisted_38 = { value: "Individually" }
const _hoisted_39 = { value: "Gram" }
const _hoisted_40 = { value: "Kilogram" }
const _hoisted_41 = { value: "Milligram" }
const _hoisted_42 = { value: "Ounce" }
const _hoisted_43 = { value: "Pound" }
const _hoisted_44 = { value: "Carat" }
const _hoisted_45 = { class: "col-sm-6" }
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = { class: "f-w-700" }
const _hoisted_48 = ["aria-label"]
const _hoisted_49 = {
  value: "",
  disabled: ""
}
const _hoisted_50 = { value: "Individually" }
const _hoisted_51 = { value: "Gram" }
const _hoisted_52 = { value: "Kilogram" }
const _hoisted_53 = { value: "Milligram" }
const _hoisted_54 = { value: "Ounce" }
const _hoisted_55 = { value: "Pound" }
const _hoisted_56 = { value: "Carat" }

import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';

import { useI18n } from 'vue-i18n'
import { productsLanguage } from '@/core/locales/products-language'


export default /*@__PURE__*/_defineComponent({
  __name: 'productStock',
  setup(__props) {

const { t } = useI18n({
  messages: productsLanguage
})

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const stockData = productGroup.stock
        compState.autoStock = stockData.autoStock
        compState.returnsCanBeRestocked = stockData.returnsCanBeRestocked
        compState.stockSource = stockData.stockSource
        compState.stockLocation = stockData.stockLocation
        compState.stockLowWatermark = stockData.stockLowWatermark
        compState.stockHighWatermark = stockData.stockHighWatermark
        compState.saleToStockUnitRatio = stockData.saleToStockUnitRatio
        compState.currentStockLevel = stockData.currentStockLevel
        compState.saleUnit = stockData.saleUnit
        compState.stockUnit = stockData.stockUnit
    }
})

const compState = reactive({
    autoStock: false,
    returnsCanBeRestocked: false,
    stockSource: false,
    stockLocation: '',
    stockLowWatermark: 0,
    stockHighWatermark: 0,
    saleToStockUnitRatio: 0,
    currentStockLevel: 0,
    saleUnit: '',
    stockUnit: ''
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const stockData = productGroup.stock
        compState.autoStock = stockData.autoStock
        compState.returnsCanBeRestocked = stockData.returnsCanBeRestocked
        compState.stockSource = stockData.stockSource
        compState.stockLocation = stockData.stockLocation
        compState.stockLowWatermark = stockData.stockLowWatermark
        compState.stockHighWatermark = stockData.stockHighWatermark
        compState.saleToStockUnitRatio = stockData.saleToStockUnitRatio
        compState.currentStockLevel = stockData.currentStockLevel
        compState.saleUnit = stockData.saleUnit
        compState.stockUnit = stockData.stockUnit
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        stock: {
            autoStock: newVal.autoStock,
            returnsCanBeRestocked: newVal.returnsCanBeRestocked,
            stockSource: newVal.stockSource,
            stockLocation: newVal.stockLocation,
            stockLowWatermark: newVal.stockLowWatermark,
            stockHighWatermark: newVal.stockHighWatermark,
            saleToStockUnitRatio: newVal.saleToStockUnitRatio,
            currentStockLevel: newVal.currentStockLevel,
            saleUnit: newVal.saleUnit,
            stockUnit: newVal.stockUnit
        }
    })

}, { deep: true });

const stockLowWatermarkIncrement = () => {
    compState.stockLowWatermark++
}

const stockLowWatermarkDecrement = () => {
    if (compState.stockLowWatermark > 0) {
        compState.stockLowWatermark--
    }
}
const stockHighWatermarkIncrement = () => {
    compState.stockHighWatermark++
}

const stockHighWatermarkDecrement = () => {
    if (compState.stockHighWatermark > 0) {
        compState.stockHighWatermark--
    }
}
const saleToStockUnitRatioIncrement = () => {
    compState.saleToStockUnitRatio++
}

const saleToStockUnitRatioDecrement = () => {
    if (compState.saleToStockUnitRatio > 0) {
        compState.saleToStockUnitRatio--
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "Single-Item-Select",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.autoStock) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.autoStock]
          ]),
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('Auto-stock')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "Show-on-Menu",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.returnsCanBeRestocked) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.returnsCanBeRestocked]
          ]),
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('Returns can be restocked')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "Stock-Source",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.stockSource) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.stockSource]
          ]),
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)('Stock Source')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_16, _toDisplayString(_unref(t)('Stock Location')), 1)
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.stockLocation) = $event)),
          class: "form-control",
          type: "text",
          placeholder: _unref(t)('Name'),
          maxlength: "32"
        }, null, 8, _hoisted_17), [
          [_vModelText, compState.stockLocation]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("label", null, [
        _createElementVNode("h6", _hoisted_19, _toDisplayString(_unref(t)('Stock Low Watermark')), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: _unref(t)('Threshold'),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.stockLowWatermark) = $event))
        }, null, 8, _hoisted_21), [
          [_vModelText, compState.stockLowWatermark]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: stockLowWatermarkDecrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: stockLowWatermarkIncrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("label", null, [
        _createElementVNode("h6", _hoisted_23, _toDisplayString(_unref(t)('Stock High Watermark')), 1)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: _unref(t)('Threshold'),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.stockHighWatermark) = $event))
        }, null, 8, _hoisted_25), [
          [_vModelText, compState.stockHighWatermark]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: stockHighWatermarkDecrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: stockHighWatermarkIncrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("label", null, [
        _createElementVNode("h6", _hoisted_27, _toDisplayString(_unref(t)('Sale to Stock Unit Ratio')), 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: _unref(t)('Threshold'),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((compState.saleToStockUnitRatio) = $event))
        }, null, 8, _hoisted_29), [
          [_vModelText, compState.saleToStockUnitRatio]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: saleToStockUnitRatioDecrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: saleToStockUnitRatioIncrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("h6", _hoisted_32, _toDisplayString(_unref(t)('Current Stock Level')) + " : " + _toDisplayString(compState.currentStockLevel), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_35, _toDisplayString(_unref(t)('Sale Unit')), 1)
        ]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((compState.saleUnit) = $event)),
          class: "form-select",
          "aria-label": _unref(t)('Sale Unit')
        }, [
          _createElementVNode("option", _hoisted_37, _toDisplayString(_unref(t)('Sale Unit')), 1),
          _createElementVNode("option", _hoisted_38, _toDisplayString(_unref(t)('Individually')), 1),
          _createElementVNode("option", _hoisted_39, _toDisplayString(_unref(t)('Gram')), 1),
          _createElementVNode("option", _hoisted_40, _toDisplayString(_unref(t)('Kilogram')), 1),
          _createElementVNode("option", _hoisted_41, _toDisplayString(_unref(t)('Milligram')), 1),
          _createElementVNode("option", _hoisted_42, _toDisplayString(_unref(t)('Ounce')), 1),
          _createElementVNode("option", _hoisted_43, _toDisplayString(_unref(t)('Pound')), 1),
          _createElementVNode("option", _hoisted_44, _toDisplayString(_unref(t)('Carat')), 1)
        ], 8, _hoisted_36), [
          [_vModelSelect, compState.saleUnit]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_47, _toDisplayString(_unref(t)('Stock Unit')), 1)
        ]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((compState.stockUnit) = $event)),
          class: "form-select",
          "aria-label": _unref(t)('Stock Unit')
        }, [
          _createElementVNode("option", _hoisted_49, _toDisplayString(_unref(t)('Stock Unit')), 1),
          _createElementVNode("option", _hoisted_50, _toDisplayString(_unref(t)('Individually')), 1),
          _createElementVNode("option", _hoisted_51, _toDisplayString(_unref(t)('Gram')), 1),
          _createElementVNode("option", _hoisted_52, _toDisplayString(_unref(t)('Kilogram')), 1),
          _createElementVNode("option", _hoisted_53, _toDisplayString(_unref(t)('Milligram')), 1),
          _createElementVNode("option", _hoisted_54, _toDisplayString(_unref(t)('Ounce')), 1),
          _createElementVNode("option", _hoisted_55, _toDisplayString(_unref(t)('Pound')), 1),
          _createElementVNode("option", _hoisted_56, _toDisplayString(_unref(t)('Carat')), 1)
        ], 8, _hoisted_48), [
          [_vModelSelect, compState.stockUnit]
        ])
      ])
    ])
  ]))
}
}

})